module.exports = __webpack_public_path__ + "static/media/portfolio-thumbnail.3f187022.jpg";